import AppPopover, { AppPopoverProps } from "../../Popover/AppPopover";
import AppPopoverContent from "../../Popover/AppPopoverContent";
import {
  RepairSpecAutocompleteCustomFiltersInput,
  RepairSpecAutocompleteCustomFiltersInputProps,
} from "./RepairSpecAutocompleteCustomFiltersInput";

interface Props extends Omit<AppPopoverProps, "ref" | "children"> {
  subProps: RepairSpecAutocompleteCustomFiltersInputProps;
}

export function RepairSpecAutocompleteCustomFiltersInputPopover({
  subProps,
  ...otherProps
}: Props) {
  return (
    <AppPopover keepMounted={false} {...otherProps}>
      {(params) => (
        <AppPopoverContent
          sx={{
            minWidth: 250,
            maxWidth: { xxs: "95vw", md: 400 },
            maxHeight: { xxs: "95vh", md: 400, lg: 500 },
          }}
        >
          {/* Render only when open to have fresh state. */}
          {params.isOpen && (
            <RepairSpecAutocompleteCustomFiltersInput
              {...subProps}
              onCancel={() => {
                subProps.onCancel?.();
                params.close();
              }}
              onSave={(newValue) => {
                subProps.onSave?.(newValue);
                params.close();
              }}
            />
          )}
        </AppPopoverContent>
      )}
    </AppPopover>
  );
}
